// Meta Pixel conversion events.
//
// Previously the site only ever fired PageView, so Meta could never see
// AddToCart / InitiateCheckout / Purchase — ad reporting showed "0 conversions"
// no matter what shoppers actually did, and the campaign had no conversion
// signal to optimize against.
//
// The fbq stub in index.html queues calls made before the real fbevents.js
// script finishes loading, so these fire safely even while the pixel is still
// being deferred for performance.

const CURRENCY = "USD";
const PRICE = 399;

function track(event, params) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (_) {
    /* never let analytics break the store */
  }
}

export function trackViewContent(extra = {}) {
  track("ViewContent", {
    content_name: "LCTX Tyre Changer",
    content_type: "product",
    content_ids: ["LCTX-TC-2024"],
    value: PRICE,
    currency: CURRENCY,
    ...extra,
  });
}

export function trackAddToCart(extra = {}) {
  track("AddToCart", {
    content_name: "LCTX Tyre Changer",
    content_type: "product",
    content_ids: ["LCTX-TC-2024"],
    value: PRICE,
    currency: CURRENCY,
    ...extra,
  });
}

export function trackInitiateCheckout(quantity = 1, extra = {}) {
  // currency/value can be overridden via extra (e.g. the customer's actual
  // local currency -- AED/SAR -- rather than the USD baseline), so Meta's ad
  // reporting/optimization reflects what the shopper is really being charged.
  track("InitiateCheckout", {
    content_name: "LCTX Tyre Changer",
    content_ids: ["LCTX-TC-2024"],
    num_items: quantity,
    value: PRICE * (Number(quantity) || 1),
    currency: CURRENCY,
    ...extra,
  });
}

export function trackPurchase(value, orderId, quantity = 1, currency = CURRENCY) {
  track("Purchase", {
    content_name: "LCTX Tyre Changer",
    content_ids: ["LCTX-TC-2024"],
    num_items: quantity,
    value: Number(value) || PRICE,
    currency,
    order_id: orderId,
  });
}

// Non-purchase conversion signal (contact form, transportation-fee/support
// request, B2B enquiry, etc.) -- previously nothing on these forms ever told
// Meta a lead happened, so lead-gen traffic had zero conversion signal.
export function trackLead(extra = {}) {
  track("Lead", {
    content_name: "LCTX Tyre Changer",
    ...extra,
  });
}
